<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="false"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>
<script>
import model from "@/models/role_type";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "id",
      "sequence",
      "name",
      "updated_at"],
    sortBy: "sequence",
  }),
};
</script>